"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const practiceAreas = [{
  title: "Business",
  description: "Practical legal guidance for South Florida business owners, including business formation, LLC operating agreements, shareholders’ agreements and corporate bylaws, contract preparation and review, and the purchase and sale of businesses. Mr. Levine has represented clients in the formation and operation of businesses and in dozens of business transactions.",
  link: "/BusinessCorporateServicesPage"
}, {
  title: "Real Estate Transactions",
  description: "Mr. Levine's real estate experience began during law school, working as a title closer in New York. His legal career started with residential and commercial real estate transactions and continues to reflect that professional foundation.",
  link: "/RealEstateTransactionsPage"
}, {
  title: "Trust & Probate Administration",
  description: "Legal guidance for trust-related matters, probate administration, estate administration, beneficiary issues, and related court proceedings.",
  link: "/EstatePlanningProbatePage"
}, {
  title: "Attorney’s Fee Hearings",
  description: "Expert Witness services for complex attorney’s fee hearings and litigation support.",
  link: "/AttorneyFeeHearingsPage"
}, {
  title: "Business Litigation",
  description: "Selective, focused representation in business disputes and commercial litigation matters.",
  link: "/BusinessLitigationPage"
}, {
  title: "Japanese Language Support",
  description: "Japanese-language intake and document organization support for local and international clients.",
  link: "/JapaneseLanguageSupportPage"
}];
export default function PracticeAreas() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  return <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div ref={headerRef} className={`mb-16 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="text-4xl md:text-5xl font-serif text-primary mb-6">Practice Areas</h2>
          <p className="text-lg text-muted-foreground max-w-2xl">The office focuses on matters where careful drafting, transaction experience, and sound judgment can materially affect the outcome—from business and real estate agreements to trust and probate matters, selected disputes, and attorney's fee proceedings.</p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 transition-all duration-700 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          {practiceAreas.map((area, index) => <div key={index} data-index={index} className="group p-8 bg-stone-50 border border-stone-100 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 flex flex-col">
              <h3 className="text-xl font-serif text-primary mb-4">{area.title}</h3>
              <p className="text-muted-foreground mb-8 flex-grow">{area.description}</p>
              <Button variant="ghost" className="w-fit px-0 hover:bg-transparent hover:text-secondary group-hover:gap-3 transition-all" asChild>
                <Link to={area.link}>
                  Learn More <ArrowRight className="size-4" />
                </Link>
              </Button>
            </div>)}
        </div>
      </div>
    </section>;
}